import SendIcon from "@redotech/redo-icons/send-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useMessageInput } from "../hooks/use-message-input";
import { MessageInputToolbar } from "./message-input-toolbar";

export const MessageInput = memo(function MessageInput() {
  const { messageContent, setMessageContent, isMessageSendLoading } =
    useMessageInput();

  return (
    <Flex dir="column" gap="sm" grow={1} py="md">
      <MessageInputToolbar />
      <RedoTextareaInputField
        actionButton={
          <RedoButton
            hierarchy="primary"
            IconTrailing={SendIcon}
            pending={isMessageSendLoading}
            size="sm"
            text="Send"
          />
        }
        autoExpand
        fullWidth
        placeholder="Type your message..."
        setValue={setMessageContent}
        value={messageContent}
      />
    </Flex>
  );
});
